// action
import {
    GET_EMPLOYEE_DROPDOWN,
    GET_EMPLOYEE_DROPDOWN_FAIL,
    GET_EMPLOYEE_DROPDOWN_SUCCESS,
    GET_EMPLOYEE_DROPDOWN_RESET
} from '../action/getEmployeeDropdownAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    list: [],
    message: ""
}

export default function(state = initialState, action) {
    switch (action.type) {
        case GET_EMPLOYEE_DROPDOWN:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_EMPLOYEE_DROPDOWN_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_EMPLOYEE_DROPDOWN_SUCCESS:
            return {
                ...state,
                apiState: "success",
                list: action.response.data.data.result,

            }
        case GET_EMPLOYEE_DROPDOWN_RESET:
            return initialState
        default:
            return state
    }
}